module.exports = __webpack_public_path__ + "files/SPIADI2026 - Journée Nationale - Programme.8e00a3306a604e5cffaac96c212e44ed.pdf";